  const CIRCLE_ANGLE = 360;
  const BIGSIZE = 24;
  let result = "";
  let surePhysical = false;
  let data = [];
  let gameValues = []; //插件信息获取

  let angleList = []; // 记录每个奖的位置
  let gift_id = 3; //中奖ID

  let index = ''; //抽中的是第几个奖品
  let isRotating = false; //为了防止重复点击
  let rotateAngle = 0;
  let bgDom = document.getElementsByClassName('luckWhellBgMain')[0];
  let divDom = document.getElementsByClassName('prize-list')[0];
  let prizeList = ""
  getGameValue()
  //每个奖增加style
  function formatPrizeList(list) {
    const l = list.length;
    // 计算单个奖项所占的角度
    const average = CIRCLE_ANGLE / l; //60
    const half = average / 2; //30			  
    const rightBig = l == 2 ? '50' : '0';
    const heightBig = l <= 3 ? '100' : '50';
    const topBig = l == 3 ? '-50' : '0';
    const skewMain = l <= 2 ? 0 : -(l - 4) * 90 / l;
    // 循环计算给每个奖项添加style属性
    list.forEach((item, i) => {
      // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
      const angle = -(i * average + half);
      const bigAge = l > 2 ? i * 360 / l : '0';
      // 增加 style 这个是给每一个奖项增加的样式
      item.style = `-webkit-transform: rotate(${-angle}deg);
          transform: rotate(${-angle}deg);
          width:${100/l*2}%;  
          margin-left: -${100/l}%;
          font-size:${BIGSIZE-l}px;`;
      //这是给每一个转盘背景新增的样式
      item.style2 = `-webkit-transform: rotate(${bigAge}deg);
          transform: rotate(${bigAge}deg) skewY(${skewMain}deg);
          right:${rightBig*i}%;
          height:${heightBig}%;
          top:${topBig}%;
          width:${l==1?100:50}%;
          background:${item.color}
          `
      // 记录每个奖项的角度范围
      angleList.push(angle);
    });
    return list;
  };
  //奖品赋值到每个奖品中；
  function prizeAddHtml(prizeList) {
    //把奖品赋值到.luckWhellBgMain
    let htmlBg = '';
    let htmlDiv = '';
    for (let i = 0, len = prizeList.length; i < len; i++) {
      htmlBg += `<div class="luckWhellSector" style="${prizeList[i].style2}"></div>`;
      htmlDiv += `<div class="prize-item"  style="${prizeList[i].style}">							
          <div>
            ${prizeList[i].prize_name}                
          </div>	
       
        </div>`
    }
    bgDom.innerHTML = htmlBg;
    divDom.innerHTML = htmlDiv;
  };
  //判断邮箱
  function isValidEmail(email) {
    // 定义一个正则表达式来匹配常见的电子邮件格式
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  //抽奖
  function prizeRoll() {
    if (isRotating) return false;

    // 获取输入框元素
    const emailInput = document.getElementById('email');

    // 获取输入框中的值
    const emailValue = emailInput.value;
    if (!isValidEmail(emailValue)) {
      alert("请输入正确邮箱")
      return false
    }

    const xhr = new XMLHttpRequest();
    const dataForm = {
      email: emailValue,
      first_name: "",
      last_name: "",
      gdpr: false,
      tcpa: false,
      locale: "ja",
      referrer: "https://4zvedqxqlg6pdnt8-39492124839.shopifypreview.com/"
    };

    const url =
      'https://api.ecomsend.com/v2/store-frontend/39492124839/popups/117893/draw';

    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status === 200) {
        let responseText = JSON.parse(xhr.responseText)
        gift_id = responseText.reward_index + 1
        if (responseText.discount_code) {
          result = responseText.discount_code
        } else {
          result = responseText.reward.label
          surePhysical = true
        }
        prizeList.forEach((item, i) => {
          if (item.id == gift_id) index = i; //判断中奖的位置
        });
        rotating();
      } else {
        alert(JSON.parse(xhr.response).message)
      }
    };
    xhr.send(JSON.stringify(dataForm));


  };
  //转盘转动角度
  function rotating() {
    isRotating = true;
    // const {rotateAngle,angleList,config,index} = {0,angleList,{duration:5000, circle: 8,mode: "ease-in-out"},index};
    const config = {
      duration: 5000,
      circle: 8,
      mode: "ease-in-out"
    }
    // 计算角度
    const angle =
      // 初始角度
      rotateAngle +
      // 多旋转的圈数
      config.circle * CIRCLE_ANGLE +
      // 奖项的角度
      angleList[index] -
      (rotateAngle % CIRCLE_ANGLE);
    rotateAngle = angle + 90;
    bgDom.style.transform = `rotate(${rotateAngle}deg)`
    divDom.style.transform = `rotate(${rotateAngle}deg)`
    // 旋转结束后，允许再次触发
    setTimeout(() => {
      isRotating = false;
      if (result != "") {
        results()
      }
    }, config.duration + 500);
  }

  function results() {
    // 获取 input 元素
    const inputElement = document.getElementById('email');

    // 创建新的 div 元素
    const newDiv = document.createElement('div');
    newDiv.className = 'result-main';
    newDiv.innerHTML = `
        <p class="result-p">${result}</p>
        <span class="Polaris-Icon" onclick="copy()">
            <span class="Polaris-VisuallyHidden"></span>
            <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                <path d="M15 2a1 1 0 0 1 1 1v13.5a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-13.5a1 1 0 1 1 2 0v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1a1 1 0 0 1 1-1zm-4 2h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2z"></path>
            </svg>
        </span>
    `;

    // 用新的 div 替换 input 元素
    inputElement.parentNode.replaceChild(newDiv, inputElement);

    if (!surePhysical) {
      document.getElementById('sureGame').outerHTML =
        '<div class="ecomsend__Button _xButton_1vm0o_2 _btn-radius-standard_1vm0o_44" style="--bg-color:#121212; background: #009CE0; color: rgb(255, 255, 255);" onclick="copy()"><div class="_text_1vm0o_33">Apply Code</div></div>' +
        `<div class="text-center btn _xButton_1vm0o_2" style="width:100%"><a class="bold" style="color:#fff" href="https://sohimi-jp.myshopify.com/discount/${result}" target="_self">コードを適用 & 今すぐ購入</a></div>`;
      document.getElementById("popupText").innerHTML  = fullDiscountReminder[gift_id-1];
      document.getElementById("popup").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      specialEffects()
    } else {
      document.getElementById('sureGame').outerHTML =
        '<div class="ecomsend__Button _xButton_1vm0o_2 _btn-radius-standard_1vm0o_44" style="--bg-color:#121212; background: #009CE0; color: rgb(255, 255, 255);" onclick="copy()"><div class="_text_1vm0o_33">Apply Code</div></div>'
      document.getElementById("popupText").innerHTML  = fullDiscountReminder[gift_id-1];;
      document.getElementById("popup").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      specialEffects()
    }

    const rightMainDiv = document.querySelector('.right-main');

    if (rightMainDiv) {
      // 将 div 元素转换为字符串并存储到 localStorage 中
      localStorage.setItem('joyhubWinningInformation', rightMainDiv.outerHTML);
    } else {
      console.error('Element with class "right-main" not found.');
    }


  }
  //文本复制
  function copy() {
    const textToCopy = result
    navigator.clipboard.writeText(textToCopy).then(function () {
      // 显示成功消息
      alert(`${copyText}`);
    }).catch(function (err) {
      // 显示错误消息
      alert('复制失败');
    });

  }
  //插件识别
  function ln(e) {
    let t = "";
    const n = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for (let r = 0; r < e; r++)
      t += n.charAt(Math.floor(62 * Math.random()));
    return t
  }
  //获取插件信息
  function getGameValue() {

    const xhr = new XMLHttpRequest();
    const url =
      'https://api.ecomsend.com/v2/store-frontend/39492124839/popups/117893';

    xhr.open('GET', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status === 200) {
        gameValues = JSON.parse(xhr.responseText);
        data = []
        gameValues.data.rules.rewards.forEach((item, index) => {
          data.push({
            id: index + 1,
            prize_name: item.label
          })
        })
        // 获取需要插入数据的DOM元素
        const titleElement = document.getElementById('game-title');
        const wheelTextElement = document.getElementById('game-wheelText');

        // 将数据渲染到页面中
        titleElement.textContent = gameValues.data.text.start_status.heading;
        wheelTextElement.textContent = gameValues.data.text.start_status.description;

        let styleSheet = document.styleSheets[0];
        if (styleSheet.insertRule) {
          styleSheet.insertRule(
            `.luckWhellSector:nth-child(2n) { background: ${gameValues.data.style.colors.wheel.bg1};}`,
            styleSheet.cssRules.length);
          styleSheet.insertRule(
            `.luckWhellSector { background: ${gameValues.data.style.colors.wheel.bg2};}`,
            styleSheet.cssRules.length);
          styleSheet.insertRule(
            `.prize-item:nth-child(2n) { color: ${gameValues.data.style.colors.wheel.text1}; }`,
            styleSheet.cssRules.length);
          styleSheet.insertRule(
            `.prize-item { color: ${gameValues.data.style.colors.wheel.text2}; }`, styleSheet
            .cssRules.length);
          styleSheet.insertRule(
            `.luckWhellSector { border-color: ${gameValues.data.style.colors.secondary_button}; }`, styleSheet
            .cssRules.length);
          styleSheet.insertRule(
            `.luckBg { background: ${gameValues.data.style.colors.sticky_discount_bar_background_color}; }`,
            styleSheet.cssRules.length);
        } else if (styleSheet.addRule) {
          styleSheet.addRule('.luckWhellSector:nth-child(2n)',
            `background: ${gameValues.data.style.colors.wheel.bg1};`);
          styleSheet.addRule('.luckWhellSector',
            `background: ${gameValues.data.style.colors.wheel.bg2};`);
           styleSheet.addRule('.prize-item', `color: ${gameValues.data.style.colors.wheel.text2};`);
          styleSheet.addRule('.prize-item:nth-child(2n)', `color: ${gameValues.data.style.colors.wheel.text1};`);
          styleSheet.addRule('.luckWhellSector', `border-color: ${gameValues.data.style.colors.secondary_button};`);
          styleSheet.addRule('.luckBg',
            `background: ${gameValues.data.style.colors.sticky_discount_bar_background_color};`);
        }
        // 获取元素
        // const prizePoint = document.querySelector('.prize_point');
        // prizePoint.style.background = gameValues.data.style.colors.sticky_discount_bar_background_color
        // prizePoint.style.setProperty('--custom-color',
        //   `transparent transparent ${gameValues.data.style.colors.sticky_discount_bar_background_color}`);
        // prizePoint.style.display = 'block'


        prizeList = formatPrizeList(data); //有样式的奖品列表
        prizeAddHtml(prizeList);
      } else {
        alert(JSON.parse(xhr.response).message)
      }
    };
    xhr.send();
    let winningDiv = localStorage.getItem("joyhubWinningInformation")
    if(winningDiv){
      document.querySelector('.right-main').outerHTML  = winningDiv
    }
  }

  function closePopup() {
    document.getElementById("popup").style.display = "none";
    document.getElementById("overlay").style.display = "none";
  }

  function specialEffects() {
//     var pumpkin = confetti.shapeFromPath({
//   path: 'M449.4 142c-5 0-10 .3-15 1a183 183 0 0 0-66.9-19.1V87.5a17.5 17.5 0 1 0-35 0v36.4a183 183 0 0 0-67 19c-4.9-.6-9.9-1-14.8-1C170.3 142 105 219.6 105 315s65.3 173 145.7 173c5 0 10-.3 14.8-1a184.7 184.7 0 0 0 169 0c4.9.7 9.9 1 14.9 1 80.3 0 145.6-77.6 145.6-173s-65.3-173-145.7-173zm-220 138 27.4-40.4a11.6 11.6 0 0 1 16.4-2.7l54.7 40.3a11.3 11.3 0 0 1-7 20.3H239a11.3 11.3 0 0 1-9.6-17.5zM444 383.8l-43.7 17.5a17.7 17.7 0 0 1-13 0l-37.3-15-37.2 15a17.8 17.8 0 0 1-13 0L256 383.8a17.5 17.5 0 0 1 13-32.6l37.3 15 37.2-15c4.2-1.6 8.8-1.6 13 0l37.3 15 37.2-15a17.5 17.5 0 0 1 13 32.6zm17-86.3h-82a11.3 11.3 0 0 1-6.9-20.4l54.7-40.3a11.6 11.6 0 0 1 16.4 2.8l27.4 40.4a11.3 11.3 0 0 1-9.6 17.5z',
//   matrix: [0.020491803278688523, 0, 0, 0.020491803278688523, -7.172131147540983, -5.9016393442622945]
// });
// // tree shape from https://thenounproject.com/icon/pine-tree-1471679/
// var tree = confetti.shapeFromPath({
//   path: 'M120 240c-41,14 -91,18 -120,1 29,-10 57,-22 81,-40 -18,2 -37,3 -55,-3 25,-14 48,-30 66,-51 -11,5 -26,8 -45,7 20,-14 40,-30 57,-49 -13,1 -26,2 -38,-1 18,-11 35,-25 51,-43 -13,3 -24,5 -35,6 21,-19 40,-41 53,-67 14,26 32,48 54,67 -11,-1 -23,-3 -35,-6 15,18 32,32 51,43 -13,3 -26,2 -38,1 17,19 36,35 56,49 -19,1 -33,-2 -45,-7 19,21 42,37 67,51 -19,6 -37,5 -56,3 25,18 53,30 82,40 -30,17 -79,13 -120,-1l0 41 -31 0 0 -41z',
//   matrix: [0.03597122302158273, 0, 0, 0.03597122302158273, -4.856115107913669, -5.071942446043165]
// });
// // heart shape from https://thenounproject.com/icon/heart-1545381/
// var heart = confetti.shapeFromPath({
//   path: 'M167 72c19,-38 37,-56 75,-56 42,0 76,33 76,75 0,76 -76,151 -151,227 -76,-76 -151,-151 -151,-227 0,-42 33,-75 75,-75 38,0 57,18 76,56z',
//   matrix: [0.03333333333333333, 0, 0, 0.03333333333333333, -5.566666666666666, -5.533333333333333]
// });
//     var count = 400;
//     var defaults = {
//       origin: {
//         y: 0.7
//       }
//     };

//     function fire(particleRatio, opts, shaps) {
//       confetti({
//         ...defaults,
//         ...opts,
//         shapes:[...shaps],
//         colors: ['#ff9a00', '#ff7400', '#ff4d00'],
//         particleCount: Math.floor(count * particleRatio)
//       });
//     }

//     fire(0.25, {
//       spread: 26,
//       startVelocity: 55,
//     },[pumpkin,tree,heart]);
//     fire(0.2, {
//       spread: 60,
//     },[pumpkin,tree,heart]);
//     fire(0.35, {
//       spread: 100,
//       decay: 0.91,
//       scalar: 0.8
//     },[pumpkin,tree,heart]);
//     fire(0.1, {
//       spread: 120,
//       startVelocity: 25,
//       decay: 0.92,
//       scalar: 1.2
//     },[pumpkin,tree,heart]);
//     fire(0.1, {
//       spread: 120,
//       startVelocity: 45,
//     },[pumpkin,tree,heart]);
var scalar = 4;
var unicorn1 = confetti.shapeFromText({ text: '💰', scalar });
var unicorn2 = confetti.shapeFromText({ text: '🎉', scalar });
var unicorn3 = confetti.shapeFromText({ text: '🛍', scalar });

    var count = 200;
var defaults = {
  origin: { y: 0.7 }
};

function fire(particleRatio, opts) {
  confetti({
    ...defaults,
    ...opts,
    shapes: [unicorn1,unicorn2,unicorn3],
    particleCount: Math.floor(count * particleRatio)
  });
}

fire(0.25, {
  spread: 26,
  startVelocity: 55,
});
fire(0.2, {
  spread: 60,
});
fire(0.35, {
  spread: 100,
  decay: 0.91,
  scalar: 0.8
});
fire(0.1, {
  spread: 120,
  startVelocity: 25,
  decay: 0.92,
  scalar: 1.2
});
fire(0.1, {
  spread: 120,
  startVelocity: 45,
});
  }